enum MessageType {
  Message = 0,
  Notification = 1,
}

export default MessageType;
